// ** Router Import
import Router from './router/Router'
import { handleKeyDown, handleRightClick } from './AppUtility'
import useKeyboardShortcut from 'use-keyboard-shortcut'

//import { defineInterceptor } from './redux/actions/auth'

const App = props => {
  const { flushHeldKeys } = useKeyboardShortcut(
    ["F12"],
    shortcutKeys => false,
    {
      overrideSystem: true,
      ignoreInputFields: false,
      repeatOnHold: false
    }
  )

  document.addEventListener('contextmenu', handleRightClick);
  document.addEventListener('keydown', function (event) {
    if (event.ctrlKey && event.key === 'c') {
        event.preventDefault();
    }
});

  return (
    <>
      <Router />
    </>
    )
}

export default App 
